import React from 'react';

const FooterContent = () => {
	return (
		<>
			<div className="footer-content">
				<h1>PIBY2</h1>
				<p>This is a Web App built for a basic implementation of Mathematics</p>
				<p>
					<span className="key">Founded &amp; Developed by </span>
					<span className="value">Devang Joshi</span>
				</p>
				<p>
					<span className="key">E-Mail: </span>
					<span className="value">devangjoshi11@gmail.com</span>
				</p>
			</div>
		</>
	);
};

export default FooterContent;
